<template>
  <div :class="`${extraClass} form-check mbr-radio`">
    <input
      :id="id"
      class="form-check-input mbr-radio__input"
      type="radio"
      :name="name"
      :value="$attrs.value"
      :checked="modelValue === $attrs.value"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <label class="custom-control-label ms-2 mbr-radio__label" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialRadio",
  props: {
    name: {
      type: String,
      required: true,
    },
    extraClass: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* !important outranks the #495057 dot, border and padding forced in custom.css */
.form-check.mbr-radio:not(.form-switch) .form-check-input.mbr-radio__input[type="radio"] {
  width: 20px;
  height: 20px;
  margin-top: 0;
  padding: 0 !important;
  vertical-align: middle;
  background: var(--mbr-color-surface);
  border: 1.5px solid var(--mbr-color-outline) !important;
  border-radius: 50%;
  cursor: pointer;
}

.form-check.mbr-radio:not(.form-switch) .form-check-input.mbr-radio__input[type="radio"]:checked {
  border-color: var(--mbr-color-label) !important;
}

.form-check.mbr-radio:not(.form-switch) .form-check-input.mbr-radio__input[type="radio"]:after {
  width: 10px !important;
  height: 10px !important;
  background: var(--mbr-color-label);
  background-image: none !important;
}

.form-check.mbr-radio:not(.form-switch) .form-check-input.mbr-radio__input[type="radio"]:active,
.form-check.mbr-radio:not(.form-switch) .form-check-input.mbr-radio__input[type="radio"]:focus {
  box-shadow: none;
}

.form-check.mbr-radio:not(.form-switch) .form-check-input.mbr-radio__input[type="radio"]:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-radio__label {
  vertical-align: middle;
  font-family: var(--mbr-font-body);
  font-size: var(--mbr-body-md-size);
  font-weight: 500;
  color: var(--mbr-color-ink-headline);
  cursor: pointer;
}
</style>
